import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { PatternFormat } from 'react-number-format';
import { useTheme } from '../../../contexts/ThemeContext';

const CPFInput = ({
  value,
  onChange,
  placeholder = '000.000.000-00',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <PatternFormat
      format="###.###.###-##"
      mask="_"
      value={value}
      onValueChange={(values) => {
        if (onChange) {
          onChange(values.value);
        }
      }}
      customInput={Input}
      placeholder={placeholder}
      style={{
        backgroundColor: theme.backgroundSecondary,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

CPFInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CPFInput; 